export const RANGE_PRICES = {
  athena: [0, 35500, 0],
  comet: [0, 40000, 0],
  cover: [0, 44300, 0],
  darkNature: [0, 60200, 0],
  everlineFiner: [0, 56700, 0],
  foreverOak: [0, 47800, 0],
  glod: [0, 81200, 0],
  highline: [0, 41700, 0],
  ikon: [0, 58900, 0],
  newline: [0, 44300, 0],
  nordic: [0, 49200, 0],
  northernShaker: [0, 48200, 0],
  squareFiner: [0, 55800, 0],
  urban: [0, 37000, 0],
}

export const WORKTOP_PRICES = {
  laminate: [0, 3995, 0],
  solidTimber: [0, 7995, 0],
  granite: [0, 18995, 0],
  marble: [0, 14995, 0],
  stainless: [0, 47400, 0],
}
